import React, { useState, useEffect } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
    Card,
    CardBody,
    CardHeader,
} from "../../../../_metronic/_partials/controls";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { baseURL, baseURLV1, imageURL } from "../../../service/API.js";
import Switch from "@material-ui/core/Switch";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useIntl } from "react-intl";
import TextField from '@material-ui/core/TextField'
import CropperImage from "../CropperImage";
import ImageUploading from "react-images-uploading";
import { Row, Col } from "react-bootstrap";
import ImageResize from "image-resize";
import Resizer from "react-image-file-resizer";
const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexWrap: "wrap",
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        maxWidth: 300,
    },
    chips: {
        display: "flex",
        flexWrap: "wrap",
    },
    chip: {
        margin: theme.spacing.unit / 4,
    },
    noLabel: {
        marginTop: theme.spacing.unit * 3,
    },
    inputColor: {
        backgroundColor: "#F4F6F9",
        borderRadius: "5px",
        borderWidth: "0",
    },
}));

export const EditNews = (props) => {
    const intl = useIntl();
    const suhbeader = useSubheader();
    const classes = useStyles();
    suhbeader.setTitle(intl.formatMessage({ id: "###", defaultMessage: "Edit News" }));
    const history = useHistory();
    const [item_image_path, setItem_image_path] = useState();
    const [nameImageItem_image_path, setNameImageItem_image_path] = useState("");
    const [is_active, setIs_active] = useState('1');

    const [imgState, setImgState] = useState()

    const [headlines, setHeadlines] = useState();
    const [short_content, setShort_content] = useState();
    const [content, setContent] = useState();
    const [popupstart, setPopupstart] = useState();
    const [popupend, setPopupend] = useState();
    const [publishstatus, setPublishstatus] = useState();
    const { user, setUser } = useState;
    const [imgCount, setImgCount] = useState(0)
    const [listImg, setListImg] = useState([])
    const [listDelete, setListDelete] = useState([])
    const [displayOrder, setDisplayOrder] = useState(0)

    const [images, setImages] = React.useState([]);
    const maxNumber = 10;
    const onChange = async (imageList, addUpdateIndex) => {
        // data for submit
        console.log('z', imageList, addUpdateIndex);
        setImages(imageList);
        if (imgCount == 0) {
            console.log('x', imgCount)
            setImgCount(imageList.length)
            await Promise.all(imageList.map(async (item, index) => {
                await handleUpload_image_Details(item.file, index)
            }))
        } else {
            console.log('y', imgCount)

            if (imageList.length > imgCount) {
                await Promise.all(imageList.map(async (item, index) => {
                    if (index > imgCount - 1) {
                        await handleUpload_image_Details(item.file, index)
                    }
                }))
                setImgCount(imageList.length)

            }
        }
        console.log('img', listImg)
    };

    const removeListIMG = (index) => {

        let arr2 = listDelete
        console.log('arr2', images)
        arr2.push(images[index].id)
        setListDelete(arr2)
        console.log('arr2', listImg)
        console.log(index)
        let arr = listImg
        arr.splice(index, 1);

        console.log(arr2)

        setListImg(arr)

    }
    const resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                500,
                3000,
                "PNG",
                100,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64"
            );
        });

    const handleUpload_image_Details = async (file, index) => {
        const image = await resizeFile(file);
        imageResize
            .play(URL.createObjectURL(file)) //แปลงไฟล์เป็น blob
            .then(async function (response) {
                const trans = dataURLtoFile(image, 'img.png')
                var formdata = new FormData();
                let token = localStorage.getItem("Token");
                formdata.append("image", trans, URL.createObjectURL(trans));
                let fullPath = ''
                var requestOptions = {
                    method: "POST",
                    body: formdata,
                    redirect: "follow",
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                };
                await fetch(`${baseURLV1}/upload`, requestOptions)
                    .then((response) => response.text())
                    .then((result) => {
                        let res = JSON.parse(result);
                        fullPath = `${baseURL}/uploads/${res.filename}`
                        setListImg(listImg => [...listImg, fullPath])
                    })
                    .catch((error) => console.log("error", error));

                await submitImageDetail(fullPath, String(props.location.state.row.id), index)

            })
            .catch(function (error) {
                console.error(error);
            });

    };

    const [stateItem_image_path, setStateItem_image_path] = useState({
        previewItem_image_path: null,
        rawItem_image_path: null,
        imageURLItem_image_path: null,
    });

    const AlertError = (message) => {
        Swal.fire("Please insert!", message, "error");
    };

    const ISOString = (data) => {
        console.log(`${data.toString().substring(0, 10)} ${data.toString().substring(11, 16)}`)
        return `${data.toString().substring(0, 10)} ${data.toString().substring(11, 16)}`
        // console.log(Date(data).toISOString())
    };

    const mapDetailsImage = async () => {
        let temp = []
        let temp2 = []
        let count = 0
        await props.location.state.row.kms_news_bannerimages.map(item => {
            if (!item.is_delete) {
                temp.push({
                    id: item.id,
                    data_url: item.image_path
                })
                temp2.push(item.image_path)
                count++
            }
            console.log(item.image_path)
        })
        setImages(temp)
        setListImg(temp2)
        setImgCount(count)
    }


    useEffect(() => {
        console.log(props.location.state)
        setDisplayOrder(props.location.state.row.ordering)
        setHeadlines(props.location.state.row.headlines);
        setShort_content(props.location.state.row.short_content);
        setContent(props.location.state.row.content);
        setItem_image_path(props.location.state.row.content);
        setPopupstart(ISOString(props.location.state.row.popupstart));
        setPopupend(ISOString(props.location.state.row.popupend));
        setItem_image_path(props.location.state.row.image)
        props.location.state.row.publishstatus ? setPublishstatus("1") : setPublishstatus("0")
        props.location.state.row.is_active ? setIs_active("1") : setIs_active("0")
        mapDetailsImage()
    }, []);

    const onSubmit = async (data) => {
        let img = {}
        if (headlines === undefined || headlines === "") {
            return AlertError("Please insert headlines !!");
        }

        if (short_content === undefined || short_content === "") {
            return AlertError("Please insert short content !!");
        }

        if (content === undefined || content === "") {
            return AlertError("Please insert content !!");
        }

        if (popupstart === undefined || popupstart === "") {
            return AlertError("Please insert popup start !!");
        }

        if (popupend === undefined || popupend === "") {
            return AlertError("Please insert popup end !!");
        }

        if (publishstatus === undefined || publishstatus === "") {
            return AlertError("Please insert publish status !!");
        }

        if (is_active === undefined || is_active === "") {
            return AlertError("Please insert active status !!");
        }

        if (item_image_path === undefined || item_image_path === "") {
            return AlertError("Please insert image !!");
        }



        var events = {
            headlines: headlines,
            short_content: short_content,
            content: content,
            popupstart: popupstart,
            popupend: popupend,
            publishstatus: publishstatus,
            is_active: is_active,
            image: item_image_path,
            listDelete: JSON.stringify(listDelete),
            ordering: String(displayOrder)
        };

        let apiUrls = `${baseURLV1}/news/news/${props.location.state.row.id}`;
        let token = localStorage.getItem("Token");
        console.log(events)
        const resultAll = axios({
            method: "put",
            url: apiUrls,
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
            data: events,
        })
            .then(async (res) => {
                history.goBack();
            })
            .catch((err) => {
                Swal.fire(
                    "Edit !",
                    "Your can not update news. !! " + err,
                    "error"
                );
            });
    };

    const handleChangeItem_image_path = async (e) => {
        if (e.target.files.length) {
            e.preventDefault();
            let file = e.target.files[0];
            var reader = new FileReader();
            e.target.value = '';

            handleImageUploadItem_image_path(file)
        }
    };

    const removeImageItem_image_path = async () => {
        setStateItem_image_path({
            previewItem_image_path: null,
            rawItem_image_path: null,
            imageURLItem_image_path: null,
        });
        setItem_image_path("");
    };

    const handleCancelUploadItem_image_path = () => {
        setStateItem_image_path({
            previewItem_image_path: null,
            rawItem_image_path: null,
            imageURLItem_image_path: null,
        });
    };

    const submitImageDetail = async (img, id, index) => {

        var events = {
            image_path: img,
            news_id: id,
        };

        let apiUrls = `${baseURLV1}/news/image`;
        let token = localStorage.getItem("Token");
        console.log(events)
        const resultAll = await axios({
            method: "post",
            url: apiUrls,
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
            data: events,
        })
            .then(async (res) => {
                console.log(res)
                console.log(index, 'images', images)

                let temp = {
                    id: res.data.id,
                    data_url: res.data.image_path
                }
                let arr = images
                console.log('arr', arr[index])
                arr[index] = temp
                setImages(arr)
                console.log(temp, arr[index], images)

            })
            .catch((err) => {

            });
    };

    const imageResize = new ImageResize({
        format: "png", // ไฟล์รูปภาพเป็น png
        quality: 0.5, // ปรับขนาดไฟล์รูปภาพให้เหลือครึ่งนึง
        width: 500, // ปรับขนาดรูปให้มีความกว้าง 500 px
    });

    function dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(","),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
    }

    const uploadimage = async (event) => {
        imageResize
            .play(URL.createObjectURL(event.target.files[0])) //แปลงไฟล์เป็น blob
            .then(function (response) {
                const trans = dataURLtoFile(response, 'image/png')
                handleImageUploadItem_image_path(trans)
            })
            .catch(function (error) {
                console.error(error);
            });
    };

    const handleImageUploadItem_image_path = async (file) => {
        const image = await resizeFile(file);
        imageResize
            .play(URL.createObjectURL(file))
            .then(async function (response) {
                const trans = dataURLtoFile(image, 'img.png')
                var formdata = new FormData();
                let token = localStorage.getItem("Token");
                formdata.append("image", trans, URL.createObjectURL(trans));
                console.log(formdata)
                var requestOptions = {
                    method: "POST",
                    body: formdata,
                    redirect: "follow",
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                };
                fetch(`${baseURLV1}/upload`, requestOptions)
                    .then((response) => response.text())
                    .then((result) => {
                        let res = JSON.parse(result);
                        setStateItem_image_path({
                            previewItem_image_path: null,
                            rawItem_image_path: null,
                            imageURLItem_image_path: null,
                        });
                        let fullPath = `${baseURL}/uploads/${res.filename}`
                        setItem_image_path(fullPath);
                        setNameImageItem_image_path(fullPath);
                    })
                    .catch((error) => console.log("error", error));
            })

    };



    return (
        <>
            <Card>
                <CardHeader title="Edit News "></CardHeader>
                <CardBody>
                    <div className="form-inline" style={{ marginBottom: "25px" }}>
                        <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
                            <span style={{ color: "red" }}>
                                *
                            </span>
                            {intl.formatMessage({ id: "###", defaultMessage: "Headlines" })}:{" "}
                        </p>
                        <input
                            name="topic"
                            style={{
                                height: "38px",
                                width: "530px",
                                backgroundColor: "#F4F6F9",
                                borderRadius: "5px",
                                borderWidth: "0",
                            }}
                            value={headlines}
                            onChange={(e) => setHeadlines(e.target.value)}
                        />

                    </div>

                    <div className="form-inline" style={{ marginBottom: "25px" }}>
                        <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
                            <span style={{ color: "red" }}>
                                *
                            </span>
                            {intl.formatMessage({ id: "###", defaultMessage: "Short Content" })}:{" "}
                        </p>
                        <input
                            name="topic"
                            style={{
                                height: "38px",
                                width: "530px",
                                backgroundColor: "#F4F6F9",
                                borderRadius: "5px",
                                borderWidth: "0",
                            }}
                            value={short_content}
                            onChange={(e) => setShort_content(e.target.value)}
                        />

                    </div>

                    <div className="form-inline" style={{ marginBottom: "25px" }}>
                        <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
                            <span style={{ color: "red" }}>
                                *
                            </span>
                            {intl.formatMessage({ id: "###", defaultMessage: "Content" })}:{" "}
                        </p>
                        <textarea

                            name="topic"
                            style={{
                                resize: 'none',
                                height: "150px",
                                width: "530px",
                                backgroundColor: "#F4F6F9",
                                borderRadius: "5px",
                                borderWidth: "0",
                            }}
                            value={content}
                            onChange={(e) => setContent(e.target.value)}
                        />

                    </div>

                    <div className="form-inline" style={{ marginBottom: '25px' }}>
                        <p style={{ marginTop: '15px', float: 'left', width: '20%' }}>
                            <span style={{ color: "red" }}>
                                *
                            </span>
                            {intl.formatMessage({ id: "###", defaultMessage: "Popup Start" })}:{' '}
                        </p>
                        <TextField
                            id="DateFrom"
                            type="date"
                            label={intl.formatMessage({ id: "102011", defaultMessage: "Date From" })}
                            className=" mb-3 mr-3"
                            value={popupstart}
                            style={{
                                height: '38px',
                                width: '185px',
                                backgroundColor: '#F4F6F9',
                                borderRadius: '5px',
                                borderWidth: '0'
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                            onChange={name => {
                                setPopupstart(name.target.value)
                            }}
                        />
                    </div>

                    <div className="form-inline" style={{ marginBottom: "25px" }}>
                        <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
                            <span style={{ color: "red" }}>
                                *
                            </span>
                            {intl.formatMessage({ id: "###", defaultMessage: "Popup End" })}:{" "}
                        </p>
                        <TextField
                            id="DateFrom"
                            type="date"
                            label={intl.formatMessage({ id: "102011", defaultMessage: "Date From" })}
                            className=" mb-3 mr-3"
                            value={popupend}
                            style={{
                                height: '38px',
                                width: '185px',
                                backgroundColor: '#F4F6F9',
                                borderRadius: '5px',
                                borderWidth: '0'
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                            onChange={name => {
                                setPopupend(name.target.value)
                            }}
                        />
                    </div>

                    <div className="form-inline" style={{ marginBottom: "25px" }}>
                        <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
                            <span style={{ color: "red" }}>
                                *
                            </span>
                            {intl.formatMessage({ id: "###", defaultMessage: "Publish Status" })}:{" "}
                        </p>
                        <select name="cars" id="cars"
                            value={publishstatus}
                            onChange={(e) => {
                                setPublishstatus(e.target.value)
                            }}
                        >
                            <option value="1">true</option>
                            <option value="0">false</option>
                        </select>

                    </div>

                    <div className="form-inline" style={{ marginBottom: "25px" }}>

                        <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
                            <span style={{ color: "red" }}>
                                *
                            </span>
                            is_active
                        </p>
                        <select name="cars" id="cars"
                            value={is_active}
                            onChange={(e) => {
                                setIs_active(e.target.value)
                            }}
                        >
                            <option value="1">true</option>
                            <option value="0">false</option>
                        </select>
                    </div>

                    <div className="form-inline" style={{ marginBottom: '25px' }}>
                        <p style={{ marginTop: '15px', float: 'left', width: '20%' }}>
                            <span style={{ color: "red" }}>
                                *
                            </span>
                            display order
                        </p>
                        <input
                            name="displayOrder"
                            type="number"
                            style={{
                                height: '38px',
                                width: '530px',
                                backgroundColor: '#F4F6F9',
                                borderRadius: '5px',
                                borderWidth: '0'
                            }}
                            value={displayOrder}
                            onChange={displayOrder => {
                                if (displayOrder.target.value >= 0) {
                                    setDisplayOrder(displayOrder.target.value)
                                }
                            }
                            }
                        />
                    </div>



                    <div className="form-inline" style={{ marginBottom: "25px" }}>
                        <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
                            <span style={{ color: "red" }}>
                                *
                            </span>
                            {intl.formatMessage({ id: "###", defaultMessage: "popup image" })} : <br></br>
                        </p>
                        <div
                            className="d-flex"
                            style={{
                                width: "530px",
                            }}>
                            <input
                                name="item_image_path"
                                style={{
                                    flexGrow: "1",
                                    height: "38px",
                                    backgroundColor: "#F4F6F9",
                                    borderRadius: "5px",
                                    borderWidth: "0",
                                }}
                                value={item_image_path}
                            />

                            <span className="btn btn-primary btn-file wbt"
                                style={{
                                    whiteSpace: "nowrap",
                                    width: "fit-content"
                                }}>
                                {intl.formatMessage({ id: "104025", defaultMessage: "Upload/Edit" })}
                                <input type="file" onChange={handleChangeItem_image_path} />
                            </span>

                            <button
                                type="button"
                                className="btn btn-danger wbt"
                                onClick={removeImageItem_image_path}
                            >
                                {intl.formatMessage({ id: "104026", defaultMessage: "delete" })}
                            </button>
                        </div>
                    </div>

                    <div
                        style={{
                            display: "block",
                            marginLeft: "auto",
                            marginRight: "auto",
                            width: "50%",
                        }}
                    >
                        {stateItem_image_path.imageURLItem_image_path ? (
                            <img
                                style={{
                                    width: "300px",
                                    height: "300px",
                                }}
                                src={stateItem_image_path.imageURLItem_image_path}
                            />
                        ) : item_image_path ? (
                            <img
                                style={{
                                    width: "300px",
                                    height: "300px",
                                }}
                                src={item_image_path}
                            />
                        ) : null}
                    </div>
                    {stateItem_image_path.imageURLItem_image_path ? (
                        <CropperImage
                            image={stateItem_image_path.imageURLItem_image_path}
                            handleCancel={handleCancelUploadItem_image_path}
                            handleUpload={handleImageUploadItem_image_path}
                            scale={1}
                        />
                    ) : (
                        ""
                    )}

                    <ImageUploading
                        multiple
                        value={images}
                        onChange={onChange}
                        maxNumber={maxNumber}
                        dataURLKey="data_url"
                    >
                        {({
                            imageList,
                            onImageUpload,
                            onImageRemoveAll,
                            onImageUpdate,
                            onImageRemove,
                            isDragging,
                            dragProps
                        }) => (
                            <div>
                                <div className="form-inline" style={{ marginBottom: "25px" }}>
                                    <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
                                        {intl.formatMessage({ id: "###", defaultMessage: "Details image" })} : <br></br>

                                    </p>
                                    <div
                                        className="d-flex"
                                        style={{
                                            width: "530px",
                                        }}>


                                        <span className="btn btn-primary btn-file wbt"
                                            style={{
                                                whiteSpace: "nowrap",
                                                width: "fit-content"
                                            }}
                                            onClick={() => {
                                                onImageUpload()
                                            }}
                                            {...dragProps}
                                        >
                                            {intl.formatMessage({ id: "104025", defaultMessage: "Upload/Edit" })}
                                        </span>

                                        {/*<button
                                            type="button"
                                            className="btn btn-danger wbt"
                                            onClick={onImageRemoveAll}
                                        >
                                            {intl.formatMessage({ id: "104026", defaultMessage: "delete all" })}
                                        </button>*/}


                                    </div>

                                </div>
                                <div className="upload__image-wrapper">

                                    <Row>
                                        {imageList.map((image, index) => (
                                            <Col style={{ marginTop: '20px' }} xs="3">
                                                <div key={index} className="image-item">
                                                    <button className="btnRight" onClick={() => {
                                                        onImageRemove(index)
                                                        console.log(index)
                                                        removeListIMG(index)
                                                    }}>
                                                        <img
                                                            style={{
                                                                width: "30px",
                                                                height: "30px",
                                                            }}
                                                            src="/media/icon/close.png" />
                                                    </button>
                                                    <img src={image.data_url} alt="" width="200" />

                                                </div>
                                            </Col>

                                        ))}
                                    </Row>

                                </div>
                            </div>
                        )}
                    </ImageUploading>





                    <div
                        className="form-inline"
                        style={{
                            marginBottom: "25px",
                        }}
                    >
                        <div
                            style={{
                                marginTop: "15px",
                                float: "left",
                                width: "20%",
                            }}
                        ></div>
                        <Link to="/NewsManagement">
                            <button type="button" className="btn btn-secondary wbt mr-5">
                                {intl.formatMessage({ id: "###", defaultMessage: "Cancel" })}
                            </button>
                        </Link>
                        <button className="btn btn-primary" onClick={() => onSubmit()}>
                            {intl.formatMessage({ id: "###", defaultMessage: "Save" })}
                        </button>
                    </div>
                </CardBody>
            </Card>
        </>
    );
};
